module.exports = __webpack_public_path__ + "static/media/essve-mood@2x.1169ec02.jpg";